import React from 'react'
import { OverlayTrigger, Popover } from 'react-bootstrap'

export const PopoverIcon = ({ placement = 'left', children, html }) => {
  const content = html ? <div dangerouslySetInnerHTML={{ __html: html }}/> : children
  return <OverlayTrigger
    trigger={['hover', 'click', 'focus']}
    placement={placement}
    popperConfig={{modifiers: {preventOverflow: {enabled: false}}}}
    overlay={<Popover id={`popover-left`}>{content}</Popover>}
  >
    <span className='generic-popover-icon'>?</span>
  </OverlayTrigger>
}
